import _extends from "@swc/helpers/src/_extends.mjs";
import _object_without_properties from "@swc/helpers/src/_object_without_properties.mjs";
import React from 'react';
import { FacebookIcon, RedditIcon, TumblrIcon, EmailIcon, TwitterIcon } from 'react-share';
export const ShareIcon = (_param)=>{
    var { type  } = _param, props = _object_without_properties(_param, [
        "type"
    ]);
    switch(type){
        case 'facebook':
            return /*#__PURE__*/ React.createElement(FacebookIcon, _extends({}, props));
        case 'twitter':
            return /*#__PURE__*/ React.createElement(TwitterIcon, _extends({}, props));
        case 'reddit':
            return /*#__PURE__*/ React.createElement(RedditIcon, _extends({}, props));
        case 'tumblr':
            return /*#__PURE__*/ React.createElement(TumblrIcon, _extends({}, props));
        case 'email':
            return /*#__PURE__*/ React.createElement(EmailIcon, _extends({}, props));
        default:
            return null;
    }
};
ShareIcon.displayName = 'ShareIcon';
export default ShareIcon;
